"use strict";

var ajaxHandler = require('shared/scripts/modules/services/ajaxHandler');

function getAvailableAddonsList(transactionId) {
    var request = {
        url: process.env.contextRoot + '/rest/transactions/' + transactionId + '/addons/all'
    };
    return ajaxHandler
        .ajaxGetJson(request)
        .then(function (availableAddons) {
            return availableAddons;
        })
        .fail(ajaxHandler.handleError('unable to get available addons'));
}

function getAddonsList(transactionId) {
    var request = {
        url: process.env.contextRoot + '/rest/transactions/' + transactionId + '/addons'
    };
    return ajaxHandler
        .ajaxGetJson(request)
        .then(function (addons) {
            return addons;
        })
        .fail(ajaxHandler.handleError('unable to get addons'));
}

function postAddonsList(model, transactionId) {
    var request = {
        url: process.env.contextRoot + '/rest/transactions/' + transactionId + '/addons',
        jsonString: JSON.stringify(model)
    };
    return ajaxHandler.ajaxPostJson(request)
        .fail(ajaxHandler.handleError('unable to post addons list : ' + request.jsonString));
}

module.exports  = {
    getAvailableAddonsList: getAvailableAddonsList,
    getAddonsList: getAddonsList,
    postAddonsList: postAddonsList
};


//////////////////
// WEBPACK FOOTER
// ./src/international/scripts/services/addonsService.js
// module id = OmGD
// module chunks = 0 3 4 6